<script setup>
import PostForm from '@frontJs/components/forms/projectManagement/smo/PostForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, smoPost } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    smoPost: {
        type: Object,
        required: false,
    },
    defaultScheduledAt: {
        type: String,
        required: false,
    },
    isPlatformConfigured: {
        type: Boolean,
        required: false,
    },
    maxContentLength: {
        type: Number,
        required: true,
    },
    maxMediaCount: {
        type: Number,
        required: true,
    },
    defaultScheduledDate: {
        type: String,
        required: false,
    },
    defaultPublicationTime: {
        type: String,
        required: true,
    },
    previousSmoPostId: {
        type: Number,
        required: false,
    },
    nextSmoPostId: {
        type: Number,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Publication - SMO - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - SMO -
        {{ smoPost ? 'Modifier la publication' : 'Nouvelle publication' }}
    </PageTitle>

    <PostForm
        :tenant="tenant"
        :smo-post="smoPost"
        :default-scheduled-at="defaultScheduledAt"
        :is-platform-configured="isPlatformConfigured"
        :max-content-length="maxContentLength"
        :max-media-count="maxMediaCount"
        :default-scheduled-date="defaultScheduledDate"
        :default-publication-time="defaultPublicationTime"
        :previous-smo-post-id="previousSmoPostId"
        :next-smo-post-id="nextSmoPostId"
    />
</template>
